
import { Mapper } from "../../../../../core/base";
import {PostalCode} from "../../../../../core/domain";
import { PostalCodeWebEntity } from "./postal-code-web-entity";

export class PostalCodeWebRepositoryMapper extends Mapper<PostalCodeWebEntity, PostalCode> {

  mapFrom(param: PostalCodeWebEntity): PostalCode {
    return {
      id: param.id,
      postalCode: param.postalCode,
      city: param.city,
    };
  }

  mapTo(param: PostalCode): PostalCodeWebEntity {
    return {
        id: param.id,
        postalCode: param.postalCode,
        city: param.city,
    };
  }

}
